import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

FileListItem.propTypes = {
    file: PropTypes.object.isRequired,
    onRemove: PropTypes.func.isRequired
}

function FileListItem(props) {
    const { t } = useTranslation();
    const { file, onRemove } = props;
    const [ statusText, setStatusText ] = useState(t('general.file_status_pending'));

    const statusClass = classNames({
        red: (file.status && file.status === 'error'),
        green: (file.status && file.status === 'success'),
     });


     /**
      * When status is changes, set statusText
      */
     useEffect(() => {
        if(file.status) {
            if(file.status === 'error'){
                setStatusText(t('general.file_status_fail'));
            } else if (file.status === 'success') {
                setStatusText('OK');
            }
        }
     }, [file.status, t])


    return (
        <tr className="FileListItem-tr">
            <td>
                {file.name}
            </td>
            <td className={statusClass}>
                {statusText}
            </td>
            <td>
                <span onClick={onRemove} className="text-danger cursor-pointer">{t('general.delete')}</span>
            </td>
        </tr>
    )
}

export default React.memo(FileListItem);